export default __webpack_public_path__ + "static/media/save_chart.e8eaf3ec.png";